var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-rfc is-flex is-centered" }, [
    _c("div", { staticClass: "box" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit($event)
            }
          }
        },
        [
          _c("h1", { staticClass: "title is-4 has-text-primary" }, [
            _vm._v("\n        Agregar RFC\n      ")
          ]),
          _c(
            "b-field",
            { attrs: { "label-for": "rfc", label: "RFC" } },
            [
              _c("b-input", {
                attrs: {
                  id: "rfc",
                  name: "rfc",
                  maxlength: "150",
                  "icon-left": "fingerprint",
                  pattern:
                    "^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$",
                  placeholder: "XAXX010101000",
                  loading: _vm.loading,
                  disabled: _vm.loading,
                  required: ""
                },
                model: {
                  value: _vm.rfc,
                  callback: function($$v) {
                    _vm.rfc = $$v
                  },
                  expression: "rfc"
                }
              })
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { "label-for": "name", label: "Nombre o Razón Social" } },
            [
              _c("b-input", {
                staticClass: "is-uppercase",
                attrs: {
                  id: "name",
                  name: "name",
                  placeholder: "Empresa SA de CV",
                  maxlength: "150",
                  "icon-left": "domain",
                  loading: _vm.loading,
                  disabled: _vm.loading,
                  required: ""
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c("b-field", { staticClass: "is-flex has-justify-content-end" }, [
            _c("button", { staticClass: "button is-primary" }, [
              _vm._v("\n          Agregar RFC\n        ")
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }